import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import WallpaperUsageHistory from '../../../domain/entities/WallpaperUsageHistory';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexWallpaperUsageHistoriesSuccess: {
      const result = action.payload as PaginatedResult<WallpaperUsageHistory>;
      return mergeResponse(state, result);
    }
    case Types.UpdateWallpaperUsageHistorySuccess: {
      const wallpaperUsageHistory = action.payload as WallpaperUsageHistory;
      const newState = {} as QueryState;
      Object.keys(state).forEach(stateKey => {
        const response = {...state[stateKey]};
        const filteredIds = response.pageToIds[1].filter(
          id => id !== wallpaperUsageHistory.id,
        );
        if (stateKey.includes(`"storyId":${wallpaperUsageHistory.storyId}`)) {
          response.pageToIds[1] = [wallpaperUsageHistory.id, ...filteredIds];
        }
        newState[stateKey] = response;
      });
      return newState;
    }
    default:
      return state;
  }
}
